"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
import type { Service } from "@/features/services/constants/services-data";
interface ServiceBenefitsSectionProps {
  service: Service;
}
export function ServiceBenefitsSection(t0) {
  const $ = _c(18);
  const {
    service
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 0,
      y: 20
    };
    t2 = {
      opacity: 1,
      y: 0
    };
    t3 = {
      once: true,
      margin: "-100px"
    };
    t4 = {
      duration: 0.7,
      ease: "easeOut"
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <motion.div initial={t1} whileInView={t2} viewport={t3} transition={t4} className="mx-auto max-w-2xl text-center"><span className="mb-3 block text-xs font-semibold tracking-[0.2em] text-primary uppercase">How It Helps</span><h2 className="font-heading text-[2.5rem] leading-[1.1] font-bold tracking-tight text-foreground sm:text-[3.2rem]">A Space to Understand, Process, and Grow</h2></motion.div>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== service.benefits) {
    t6 = service.benefits.map(_temp);
    $[5] = service.benefits;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t6) {
    t7 = <div className="mt-16 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:gap-8">{t6}</div>;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t10;
  let t11;
  let t8;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      opacity: 0,
      y: 10
    };
    t9 = {
      opacity: 1,
      y: 0
    };
    t10 = {
      once: true
    };
    t11 = {
      duration: 0.6,
      delay: 0.3
    };
    $[9] = t10;
    $[10] = t11;
    $[11] = t8;
    $[12] = t9;
  } else {
    t10 = $[9];
    t11 = $[10];
    t8 = $[11];
    t9 = $[12];
  }
  let t12;
  if ($[13] !== service.benefitsClarifier) {
    t12 = <motion.p initial={t8} whileInView={t9} viewport={t10} transition={t11} className="mx-auto mt-12 max-w-2xl text-center text-sm leading-relaxed text-muted-foreground italic">{service.benefitsClarifier}</motion.p>;
    $[13] = service.benefitsClarifier;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== t12 || $[16] !== t7) {
    t13 = <section className="relative border-t border-border bg-muted/30 py-24 sm:py-32"><div className="mx-auto max-w-6xl px-6 sm:px-10 lg:px-12">{t5}{t7}{t12}</div></section>;
    $[15] = t12;
    $[16] = t7;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  return t13;
}
function _temp(benefit, idx) {
  return <motion.div key={benefit.title} initial={{
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: "-50px"
  }} transition={{
    duration: 0.6,
    delay: idx * 0.1
  }} className="group rounded-3xl border border-border bg-card p-8 shadow-[0_4px_20px_rgba(0,0,0,0.02)] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_12px_32px_rgba(0,0,0,0.04)] sm:p-10"><div className="mb-5 flex h-11 w-11 items-center justify-center rounded-2xl border border-primary/10 bg-primary/[0.05] text-lg font-bold text-primary">0{idx + 1}</div><h3 className="mb-3 font-heading text-xl font-bold text-foreground">{benefit.title}</h3><p className="text-[15px] leading-relaxed font-light text-muted-foreground">{benefit.description}</p></motion.div>;
}